import { actions } from '..';
import * as apiCallHistory from '../../api/history-control';
import { selectCalls } from '../reducers/calls';
import { all } from 'async-saga';
import { takeEvery, wireUpApi } from '../tools/async-saga-types';

const fetchCalls = wireUpApi(actions.fetchCalls, (state, payload) => !selectCalls(state, payload))

const clearCalls = takeEvery(actions.clearCalls, async (ctx, folder) => {
  await apiCallHistory.clearCallFolder(folder)
})

export default all(
  fetchCalls,
  clearCalls,
)
